import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { FlightsService } from '../../shared/services/flights/flights.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { environment } from 'src/environments/environment';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-flight-search',
  templateUrl: './flight-search.component.html',
  styleUrls: ['./flight-search.component.scss'],
})
export class FlightSearchComponent implements OnInit {

  transportGroup: any;
  tripDetails: any;

  searchForm!: FormGroup;

  allFlights: any[] = [];

  tripTypes = [
    { id: 1, name: 'One Way' },
    { id: 2, name: 'Round Trip' }
  ];

  cabinClass = [
    { id: 1, name: 'All' },
    { id: 2, name: 'Economy' },
    { id: 3, name: 'Premium Economy' },
    { id: 4, name: 'Business' },
    { id: 5, name: 'Premium Business' },
    { id: 6, name: 'First Class' }
  ]

  selectedFlights: any[] = [];
  @Input() onFlightSelected!: (data: any) => void;

  constructor(
    private fb: FormBuilder,
    private _flightService: FlightsService,
    private _responseService: ResponseNotificationService,
    private _modalController: ModalController
  ) { }

  ngOnInit() {
    this.searchForm = this.fb.group({
      tripType: [1, Validators.required],
      departureAirport: ['', Validators.required],
      arrivalAirport: ['', Validators.required],
      noOfGuests: [{ noOfAdults: this.tripDetails.totalAdults || 0, noOfChildren: this.tripDetails.totalChildrens || 0, noOfInfants: this.tripDetails.totalInfants || 0 }, Validators.required],
      departureDate: ['', Validators.required],
      arrivalDate: [''],
      class: [1]
    });

    this.searchForm.get('tripType')?.valueChanges.subscribe(value => {
      if(value == 1){
        this.searchForm.get('arrivalDate')?.setValidators([]);
      }else{
        this.searchForm.get('arrivalDate')?.setValidators([Validators.required]);
      }
      this.searchForm.get('arrivalDate')?.updateValueAndValidity();
    })
  }

  today() {
    return new Date();
  }

  searchFlights() {
    if (this.searchForm.invalid) {
      this._responseService.showMessage("Fill all required details to search", true);
      this.searchForm.markAllAsTouched();
      return;
    }

    const guests = this.searchForm.value.noOfGuests;

    const payload = {
      JourneyType: this.searchForm.value.tripType,
      AdultCount: guests.noOfAdults,
      ChildCount: guests.noOfChildren,
      InfantCount: guests.noOfInfants,
      Segments: this.getSearchSegmants(this.searchForm.value)
    };

    // API Call

    this._flightService.getAllFlightData(payload).subscribe({
      next: (res) => {
        console.log(res);
        if (res && res.length == 0) {
          this._responseService.showMessage("No Flights Found.", true);
        }
        this.allFlights = res;
        this.selectedFlights = [];
      },
      error: (err) => {
        console.error(err);
        this._responseService.showMessage("Unable to fetch flight details, try again later", true);
      }
    })

  }

  onFlightSelect(flight: any, flightIndex: number) {
    this.selectedFlights[flightIndex] = flight;
  }

  addFlightsToTransportation() {
    const selectedFlights = this.selectedFlights.filter(flight => flight);

    if (selectedFlights.length === 0) {
      return;
    }

    this.onFlightSelected(selectedFlights);
    this.closeModal();
  }

  getDuration(minutes: number) {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hrs}h ${mins}m`;
  }

  formatDateForPayload(date: any) {
    if (!date) return null;
    const d = (date instanceof Date) ? date : new Date(date);
    if (isNaN(d.getTime())) return null;
    const pad = (n: number) => n.toString().padStart(2, '0');
    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1);
    const day = pad(d.getDate());
    return `${year}-${month}-${day}T00:00:00`;

  }

  getAirlineLogo(flight: any) {
    var url = `${environment.blobpublic}/data/airline_logo/${flight.AirlineCode}.png`
    return url;
  }

  closeModal() {
    this._modalController.dismiss();
  }

  getSearchSegmants(formValue: any):any {
    var res: any;
    if (formValue.tripType == 2) {
      res = [
        {
          Origin: formValue.departureAirport?.code,
          Destination: formValue.arrivalAirport?.code,
          PreferredDepartureTime: this.formatDateForPayload(formValue.departureDate),
          PreferredArrivalTime: this.formatDateForPayload(formValue.departureDate),
          FlightCabinClass: formValue.class
        },
        {
          Origin: this.searchForm.value.arrivalAirport?.code,
          Destination: this.searchForm.value.departureAirport?.code,
          PreferredDepartureTime: this.formatDateForPayload(this.searchForm.value.arrivalDate),
          PreferredArrivalTime: this.formatDateForPayload(this.searchForm.value.arrivalDate),
          FlightCabinClass: formValue.class
        }
      ]
    } else {
      res = [
        {
          Origin: formValue.departureAirport?.code,
          Destination: formValue.arrivalAirport?.code,
          PreferredDepartureTime: this.formatDateForPayload(formValue.departureDate),
          PreferredArrivalTime: this.formatDateForPayload(formValue.departureDate),
          FlightCabinClass: formValue.class
        }
      ]
    }
    return res;
  }

}